import React from 'react';
import classNames from 'classnames';

import BurialType from '../burial-type';

import { AVAILABLE_LOT_TYPES } from 'src/constants';
import { useLocalization } from 'src/contexts/localization-context';

import './burial-types-list.scss';

const BurialTypesList = () => {
  const { getLocalization } = useLocalization();
  const burialTypesClasses = classNames(
    'burial-types-list__items',
    AVAILABLE_LOT_TYPES.length === 1 && 'burial-types-list__items_single-item'
  );

  return (
    <nav className="burial-types-list">
      <ul className={burialTypesClasses} aria-label={getLocalization('Map filters links')}>
        {AVAILABLE_LOT_TYPES.map((type) => (
          <li className="burial-types-list__item" key={type}>
            <BurialType type={type} />
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default BurialTypesList;
